module.exports = __webpack_public_path__ + "img/develop_bg.9e6ab04e.jpg";